import { render } from "./AddDeptControl.vue?vue&type=template&id=1b4aac2c"
import script from "./AddDeptControl.vue?vue&type=script&lang=js"
export * from "./AddDeptControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__